module.exports = __webpack_public_path__ + "static/media/Keypoints.6d22ac96.png";